export class CurrentEmploymentModel {
    employerId: number = 0;
    employerName: string = '';
    payrollNumber: string = '';
    joinDate: Date = null;
    lastContribution: Date = null;
}